// Client for the local OchrePoint SMS Bridge (see tools/sms-bridge). The bridge
// runs on the computer with a USB-attached Android phone and sends SMS via adb.

const LS = 'smsBridgeUrl';
const DEFAULT = 'http://127.0.0.1:8791';

export interface SmsDevice { serial: string; state: string; }
export interface SmsBridgeHealth { adb: boolean; devices: SmsDevice[]; ready: boolean; }

export const getSmsBridgeUrl = (): string => localStorage.getItem(LS) || DEFAULT;
export const setSmsBridgeUrl = (u: string): void => localStorage.setItem(LS, (u || DEFAULT).trim());

const NOT_REACHABLE = 'SMS bridge not reachable — is the helper running on the computer with the phone? See tools/sms-bridge.';

export async function smsBridgeHealth(): Promise<SmsBridgeHealth> {
  const base = getSmsBridgeUrl().replace(/\/+$/, '');
  let r: Response;
  try { r = await fetch(`${base}/health`); } catch { throw new Error(NOT_REACHABLE); }
  if (!r.ok) throw new Error(`SMS bridge error (HTTP ${r.status})`);
  return r.json();
}

export async function sendSmsViaBridge(number: string, text: string): Promise<void> {
  const base = getSmsBridgeUrl().replace(/\/+$/, '');
  let res: Response;
  try {
    res = await fetch(`${base}/sms`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ number, text }),
    });
  } catch {
    throw new Error(NOT_REACHABLE);
  }
  if (!res.ok) {
    let msg = `SMS failed (HTTP ${res.status})`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* keep */ }
    throw new Error(msg);
  }
}
